import { GlDisclosureDropdownItem, GlDisclosureDropdownGroup } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, __ } from '~/locale';
import { showForkSuggestion } from '~/repository/utils/fork_suggestion_utils';
import { DEFAULT_BLOB_INFO } from '~/repository/constants';
import getRefMixin from '~/repository/mixins/get_ref';
import UploadBlobModal from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/components/upload_blob_modal.vue?vue3';
const REPLACE_BLOB_MODAL_ID = 'modal-replace-blob';
export default {
    name: 'CEBlobButtonGroup',
    i18n: {
        replace: __('Replace')
    },
    replaceBlobModalId: REPLACE_BLOB_MODAL_ID,
    components: {
        GlDisclosureDropdownItem,
        GlDisclosureDropdownGroup,
        UploadBlobModal
    },
    mixins: [
        getRefMixin
    ],
    inject: {
        selectedBranch: {
            default: ''
        },
        originalBranch: {
            default: ''
        },
        blobInfo: {
            default: ()=>DEFAULT_BLOB_INFO.repository.blobs.nodes[0]
        }
    },
    props: {
        currentRef: {
            type: String,
            required: true
        },
        isUsingLfs: {
            type: Boolean,
            required: false,
            default: false
        },
        userPermissions: {
            type: Object,
            required: true
        },
        isReplaceDisabled: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'show-fork-suggestion'
    ],
    computed: {
        replaceFileItem () {
            return {
                text: this.$options.i18n.replace,
                extraAttrs: {
                    'data-testid': 'replace',
                    disabled: this.isReplaceDisabled || !this.userPermissions.createMergeRequestIn
                }
            };
        },
        replaceCommitMessage () {
            return sprintf(__('Replace %{name}'), {
                name: this.blobInfo.name
            });
        },
        shouldShowForkSuggestion () {
            return showForkSuggestion(this.userPermissions, this.isUsingLfs, this.blobInfo);
        }
    },
    methods: {
        showModal () {
            if (this.shouldShowForkSuggestion) {
                this.$emit('show-fork-suggestion');
                return;
            }
            this.$refs[this.$options.replaceBlobModalId].show();
        }
    }
};
